import styled from '@emotion/styled';
import * as React from 'react';
import { createPortal, findDOMNode } from 'react-dom';

type Props = {
  background: Function,
  backgroundColor?: string,
  className: ?string,
  isKiosk: ?boolean,
  isLarge: ?boolean,
  isLargeKioskScreen: ?boolean,
  isShown: ?boolean,
  source: ?{
    backgroundImage?: string,
    kioskBackgroundImage?: string,
    largeBackgroundImage?: string,
    largeKioskBackgroundImage?: string,
  },
  style: ?string,
};

export const Background = ({
  background,
  backgroundColor,
  className,
  isKiosk = false,
  isLarge = false,
  isLargeKioskScreen = false,
  isShown = true,
  source,
  style,
}: Props) => {
  const portal = findDOMNode(background);
  let prioritisedBackgroundSources = [];

  if (source) {
    prioritisedBackgroundSources = [
      isKiosk && isLargeKioskScreen && source.largeKioskBackgroundImage,
      isKiosk && source.kioskBackgroundImage,
      isLarge && source.largeBackgroundImage,
      source.backgroundImage,
    ];
  }

  const imgSource = prioritisedBackgroundSources.find(Boolean);

  if (portal instanceof HTMLElement && isShown) {
    return createPortal(
      <Bg
        backgroundColor={backgroundColor}
        className={className}
        data-test="background"
        source={imgSource}
        style={style}
      />,
      portal
    );
  }

  return null;
};

const Bg = styled.div`
  height: 100%;
  ${({ source }) => source && `background: url(${source}) center / cover no-repeat;`});
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.color.lighterGrey};
`;
